module.exports = __webpack_public_path__ + "static/media/cutout.d544097d.png";